export default "__VITE_ASSET__lyhEcw4R__"